import { Component, ViewContainerRef, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MessageService, AccountService } from '../../../services';
import { RegisterModel, LoginModel } from '../../../models/account';
import { AppUtils } from '../../../helpers/app.utils';

declare var activateFormLineControlPlaceholder: any;

@Component({
    selector: 'Register',
    templateUrl: './register.component.html'
})

export class RegisterComponent implements OnInit {
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onLoadCurrentUserProfile: EventEmitter<any> = new EventEmitter();
    @BlockUI('frm-registration') blockUI: NgBlockUI;

    constructor(protected router: Router,
        protected vcr: ViewContainerRef,
        private toastr: ToastsManager,
        private modalService: NgbModal,
        private appUtils: AppUtils,
        private messageService: MessageService,
        private accountService: AccountService) {
        this.toastr.setRootViewContainerRef(vcr);
    }
    modalReference: any;
    model: RegisterModel = {
        userType: 'creator',
        profileName: null,
        email: null,
        password: null,
        confirm: null,
        acceptTerms: false
    };

    loginModel: LoginModel;

    ngOnInit() {
        activateFormLineControlPlaceholder();
    }

    register() {
        this.blockUI.start();
        this.accountService.register(this.model)
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    this.router.navigate([`/account/created/${data}`]);
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    login() {
        this.loginModel = {
            userName: this.model.profileName,
            password: this.model.password
        };

        this.blockUI.start();
        this.accountService.login(this.loginModel)
            .subscribe(
                data => {
                    localStorage.setItem('AuthToken', data.toString());
                    this.messageService.loadCurrentUserProfile();
                    this.blockUI.stop();
                    this.router.navigate(['/'], { queryParams: { accType: 'n' } });
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    open(content: any) {
        this.modalReference = this.modalService.open(content);
    }

    close() {
        this.modalReference.close();
    }

}



// WEBPACK FOOTER //
// ./src/components/account/register/register.component.ts